import { createContext, useContext } from "react";

/** Interface */
interface ISubstitutionPlanContactModalContext {
	substitutionPlanProjectItemId: string;
}

/** Context */
export const SubstitutionPlanContactModalContext =
	createContext<ISubstitutionPlanContactModalContext>({} as ISubstitutionPlanContactModalContext);

/** Hooks */
export function useSubstitutionPlanContactModalContext() {
	return useContext(SubstitutionPlanContactModalContext);
}
